import auth from './auth';
import account from './account';
import error from './error';
import fetch from './fetch';
import users from './users';
import requests from './requests';
import pool from './pool';
import admin from './admin';
const reducers = {
	auth,
	account,
	error,
	fetch,
	users,
	requests,
	pool,
	admin,
};

export default reducers;
